import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=5c4b72fe&"
import script from "./accountForm.vue?vue&type=script&lang=js&"
export * from "./accountForm.vue?vue&type=script&lang=js&"
import style0 from "./accountForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports